export class ConnectionTimeoutError extends Error {
    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, ConnectionTimeoutError.prototype);
        this.name = 'ConnectionTimeoutError';
    }
}
